<template>
  <VTour
    v-bind="$attrs"
    :autoStart="autoStartComputed"
    saveToLocalStorage="custom"
    :buttonLabels="buttonLabels"
  >
    <template v-slot:content="{step}">
      <h3
        v-bind:innerHTML="step.getCurrentStep.title"
        v-if="!!step.getCurrentStep.title"
      ></h3>
      <div
        :class="step.getCurrentStep.hideArrow ? 'hide-arrow' : null"
        v-bind:innerHTML="step.getCurrentStep.content"></div>
    </template>
  </VTour>
</template>

<script setup lang="ts">
import store from '@/store'
import { computed } from 'vue';

const buttonLabels = { next: "次へ", prev: "前へ", finish: "終了する", skip: "閉じる"}

const autoStartComputed = computed(() => store.getters['loginUser/staff'] ? ( store.getters['loginUser/staff'].isEnabledGuidetour ? true : false ) : true)
</script>

<style lang="scss">
$vjt__tooltip_background: rgb(var(--v-theme-water));
$vjt__highlight_outline: 3px solid rgb(var(--v-theme-water));
$vjt__tooltip_max_width: 500px;
$vjt__tooltip_font_size: 16px;
$vjt__tooltip_arrow_size: 18px;
$vjt__tooltip_border_radius: 10px;
$vjt__action_button_font_size: 16px;
$vjt__action_button_background_hover: rgba(var(--v-theme-white), 0.15);

@import "@globalhive/vuejs-tour/src/style/style.scss";

#vjt-tooltip {
  border: 4px solid #000 !important;
  padding: 20px;
  .vjt-actions {
    margin-top: 30px;
  }
  h3 {
    margin-bottom: 20px;
  }

  &[data-popper-placement='top'] {
    #vjt-arrow {
      &::before {
        border: 4px solid;
        border-color: transparent #000 #000 transparent;
      }
    }
  }
  &[data-popper-placement='bottom'] {
    #vjt-arrow {
      &::before {
        border: 4px solid;
        border-color: #000 transparent transparent #000;
      }
    }
  }
  &[data-popper-placement='left'] {
    #vjt-arrow {
      &::before {
        border: 4px solid;
        border-color: #000 #000 transparent transparent;
      }
    }
  }
  &[data-popper-placement='right'] {
    #vjt-arrow {
      &::before {
        border: 4px solid;
        border-color: transparent transparent #000 #000;
      }
    }
  }

}

#vjt-tooltip:has(.hide-arrow) {
  > #vjt-arrow {
    display: none;
  }
}
</style>
